/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".no-default-action[_ngcontent-%COMP%]{display:block}tr[_ngcontent-%COMP%]:nth-child(even){background-color:#f2f2f2}"];
export { styles as styles };
